export const preoperativeMedicalAdmission = {
	history_of_current_disease: "",
	personal_background: "",
	physical_examination: "",
	provisional_diagnosis: "",
	definitive_diagnosis: "",
	place_of_origin: "",
	transfers_date: "",
	place_of_destination: "",
	reason: "",
	attendance_date: "",
	user_id: "",
	user: {} as UserIdAndName | null,
	responsible_id: "",
	responsible: {} as UserIdAndName | null,
};
